import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WhyMSTech.css';
import Testimonials from '../Testimonials/Testimonials';
import { ROUTES } from '../../utils/routes';

const heroBg = process.env.PUBLIC_URL + '/images/mstechno/whymsbnr.jpg';

export default function WhyMSTech() {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate(ROUTES.HOME);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateContact = () => {
    navigate(ROUTES.CONTACT);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [whyMSTechData, setWhyMSTechData] = useState({
    why_ms_technologies: {},
    testimonials: [],
    site_settings: {}
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    console.log("Leadership API calling...");
    fetch(`${process.env.REACT_APP_API_URL}/why-ms-technologies`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": process.env.REACT_APP_API_URL_USERNAME,
        "api-password": process.env.REACT_APP_API_URL_PASSWORD
      },
      body: JSON.stringify({})
    })
      .then((response) => {
        console.log("API Status:", response.status);
        return response.json();
      })
      .then((data) => {
        console.log("Leadership API Response:", data);
        setWhyMSTechData(data);
      })
      .catch((error) => {
        console.log("API Error:", error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <>
      {/* ── Banner ── */}
      <section
        className="wmt-banner inner-page-banner"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="wmt-banner-overlay inner-page-banner-overlay" />
        <div className="container wmt-banner-inner inner-page-banner-inner">
          <h1 className="inner-page-banner-title">Why MS Technologies</h1>
        </div>
      </section>

      <div className="inner-page-breadcrumb-wrap">
        <div className="container">
          <nav className="inner-page-breadcrumb">
            <button type="button" className="inner-page-home" onClick={handleNavigateHome}>Home</button>
            <span className="inner-page-sep"><i className="bi bi-chevron-right" /></span>
            <span className="inner-page-current">Why MS Technologies</span>
          </nav>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: whyMSTechData.why_ms_technologies.description || "" }} />
      {/* ── Testimonial ── */}
      <Testimonials />
      {/* ── CTA ── */}
      <section className="wmt-cta-section">
        <div className="container-fluid px-5">
          <div className="wmt-cta-inner">
            <div className="wmt-cta-text">
              <h2 className="wmt-cta-heading">Ready to start your transformation?</h2>
              <p className="wmt-cta-sub">Talk to an expert about how we can help your organisation move forward.</p>
            </div>
            <a href={`mailto:${whyMSTechData.site_settings.email}`} className="btn-wmt-cta">
              Talk to an Expert
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
